import React from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Link } from 'react-router';
import "./style.scss";
export const ErrorPage: React.FC = () => {
    const error = useRouteError();
    
    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            return (
                <section className={`section section_error error-${error.status}`}>
                    <div className="inside-wrapper">
                        <h1 className="section__title">404</h1>
                        <p className="section__status">Page not found</p>
                        <p className="section__description">
                            The page you're looking for doesn't exist or has been moved.
                        </p>
                        <Link to="/" className="btn btn_cta btn_lg btn_extrapad">
                            Go to Homepage
                        </Link>
                    </div>
                </section>
            );
        }

        if (error.status === 500) {
            return (
                <section className={`section section_error error-${error.status}`}>
                    <div className="inside-wrapper">
                        <h1 className="section__title">500</h1>
                        <p className="section__status">Server Error</p>
                        <p className="section__description">
                            Something went wrong on our end. Please try again later.
                        </p>
                        <button onClick={() => window.location.reload()} className="btn btn_cta btn_lg btn_extrapad">
                            Try Again
                        </button>
                    </div>
                </section>
            );
        }
    }

    return (
        <section className={`section section_error error-unknown`}>
            <div className="inside-wrapper">
                <h1 className="section__title">Oops!</h1>
                <p className="section__status">Something went wrong</p>
                <p className="section__description">
                    {error instanceof Error ? error.message : 'An unexpected error occurred.'}
                </p>
                <button onClick={() => window.location.reload()} className="btn btn_cta btn_lg btn_extrapad">
                    Try Again
                </button>
            </div>
        </section>
    );
};

export default ErrorPage; 